<template>
<div class="row">
  <div class="col-xs-12">
    <bo-user-list title="Utilisateurs"
                  subtitle="Programme National"
                  storePrefix="user"
                  routePrefix="spiadi"
                  :keepLast="false"
                  :parentAll="all"></bo-user-list>
  </div>
</div>
</template>

<script>
import boUserList from '@/components/bouserlist'
import { mapState } from 'vuex'

export default {
  name: 'mission-list',

  computed: mapState({
    all: state => state.user.all
  }),

  created () {
    this.$store.dispatch('user/all')
  },

  components: {
    'bo-user-list': boUserList
  }
}
</script>

<style scoped lang="less">
</style>
